"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useTable = function (data, page, rowsPerPage) {
    var _a = react_1.useState([]), tableRange = _a[0], setTableRange = _a[1];
    var _b = react_1.useState([]), slice = _b[0], setSlice = _b[1];
    var calculateRange = function (data, rowsPerPage) {
        var range = [];
        var num = Math.ceil(data.length / rowsPerPage);
        var i = 1;
        for (var i_1 = 1; i_1 <= num; i_1++) {
            range.push(i_1);
        }
        return range;
    };
    var sliceData = function (dataParam, pageParam, rowsPerPageParam) {
        return dataParam.slice((pageParam - 1) * rowsPerPageParam, pageParam * rowsPerPageParam);
    };
    react_1.useEffect(function () {
        var range = calculateRange(data, rowsPerPage);
        setTableRange(__spreadArrays(range));
        var newSlice = sliceData(data, page, rowsPerPage);
        setSlice(__spreadArrays(newSlice));
    }, [data, setTableRange, page, setSlice]);
    return { slice: slice, range: tableRange };
};
exports.default = useTable;
